module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Layout Admin */

(function (fox, $) {
  "use strict";

  const windowUtils = require("../../../../../components/utils/window")(fox, $);
  const links = require("../../../../../components/utils/links")(fox);
  const CONSTANTS = require("../../../../../components/utils/constants")(
    fox,
    $
  );

  fox.registerWidget(
    "Layout_Admin_LayoutHeader",
    {
      configure: function () {
        this.registerOptions("", {
          autoRender: true,
          template: "layout_admin_layoutHeader",
          "embed.container": ".layout-header-wrapper",
          widgets: {
            sectionMenu: {
              widget: "Menu_Section",
              "widgets.menu.embed.container": ".top-menu",
            },
            sidebarMenu: {
              widget: "Menu_Sidebar",
              menusList: {
                home: {
                  widget: "Widget",
                  template: "menu_sidebar_home",
                },
                about: {
                  widget: "Widget",
                  template: "menu_sidebar_about",
                },
                "guest-settings": {
                  widget: "Widget",
                  template: "menu_sidebar_contentSettings_en",
                },
                account: {
                  widget: "Widget",
                  template: "menu_sidebar_account",
                },
                "affiliate-dashboard": {
                  widget: "Widget",
                  template: "menu_sidebar_affiliate",
                },
                support: {
                  widget: "Menu_Support",
                },
              },
              handleDom: {
                hideClickToLink: {
                  event: "click",
                  target: ".menu-item",
                  callback: "@parent:toggleMobileMenu",
                },
              },
            },
            serviceMenu: {
              widget: "Menu_Service",
              "widgets.menu.embed.container": ".third-links",
            },
            langSwitcher: {
              widget: "LangSwitcher",
              "embed.container": "#member-lang-switcher",
            },
            mobileRefLink: {
              widget: "RefLink",
              container: ".ref-link-wrapper-menu",
            },
          },
          handleWom: {
            siteStateChange: {
              widget: "@root",
              event: "site.state.change",
              callback: "_handleSiteStateChange",
            },
          },
          handleDom: {
            show: {
              target: ".show",
              callback: "showMobileMenu",
            },
            logout: {
              target: "#logout",
              event: "click",
              callback: function () {
                fox.site.logout();
              },
            },
            hide: {
              target: ".close, .backdrop, .link, .btn, .btn-link, .menu-item",
              callback: function () {
                this.toggleMobileMenu(false);
              },
            },
            /* scrollTo: {
              target: "[scroll-to]",
              callback: "scrollToBlock",
            }, */
          },
        });

        this.callParent("configure", arguments);
      },

      init: function () {
        var agencyName = fox.getEnv("public.agencyName");
        var logo = fox.getEnv("siteLogo");
        this.isDesktop = 1;
        if (fox.getEnv("public.agencyId") > 0 && logo) {
          var logoUrl = require("../../../../images/logos/" + logo);

          this.setTemplateOptions("siteLogo", logoUrl);
        }

        if (agencyName) {
          this.setTemplateOptions("agencyName", agencyName);
        }

        this.callParent("init", arguments);
      },
      running() {
        /* this.resizeHandlerExterminator = windowUtils.listenResize((dimm, e) => {
          this.renderMenu();
          console.log("running");
        }); */

        this.renderMenu();
      },
      prepareEmbeddedWidgets: function () {
        this._bindData = {};

        this.bindTemplateVariables(this._bindData, ["state"]);

        var state = !!fox.getEnv("siteProps.stateAlias")
          ? fox.getEnv("siteProps.stateAlias")
          : "active";

        this._bindData.state = state;

        this.callParent("prepareEmbeddedWidgets", arguments);
      },

      _handleSiteStateChange: function (state) {
        this._bindData.state = state;
      },
      renderMenu() {
        const isDesktop = Number(
          windowUtils.isWidthUp(CONSTANTS.desktopBreakPoint, true)
        );

        this.isDesktop = isDesktop;

        const options = {
          isDesktop,
          links,
        };

        this.setTemplateOptions(options);
        this.render();
      },

      /*  scrollToBlock(elm) {
        const target = elm.getAttribute("scroll-to") || "home";

        this.scrollTo(target);
      }, */

      /* scrollTo(alias) {
        const delta = windowUtils.isWidthDown(CONSTANTS.desktopBreakPoint)
          ? CONSTANTS.headerHeight.mobile
          : CONSTANTS.headerHeight.desktop;

        windowUtils.scrollToBlock(`[block-alias="${alias}"]`, -delta);
      }, */
      toggleMobileMenu(state) {
        const w = this;
        const elm = w.dom1(".mobile-menu");

        if (!elm) {
          return;
        }

        fox.dom[state === true ? "addClass" : "removeClass"]("visible", elm);
      },

      showMobileMenu() {
        this.toggleMobileMenu(true);
      },
    },
    "Widget"
  );
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/layout/admin/header/layoutHeader.js
// module id = 316
// module chunks = 2